import VehicleService from '../../services/portefeuille/VehicleService'
import PortefeuilleService from '../../services/portefeuille/PortefeuilleService'

const Vehicles = {
    namespaced: true,
    state: {
        listeVehicles: [],
        count: 0,
        errors: {},
        loading: false
    },
    getters: {
        listeVehicles: state => state.listeVehicles,
        count: state => state.count,
        loading: state => state.loading
    },
    mutations: {
        setLoadingState(state, loading) {
            state.loading = loading
        },
        setVehicles(state, vehicles) {
            state.listeVehicles = Array.isArray(vehicles) ? vehicles : []
            state.count = state.listeVehicles.length
            state.errors = {}
        },
        addVehicleCommit(state, vehicle) {
            state.listeVehicles.push(vehicle)
            state.count = state.listeVehicles.length
        },
        updateVehicleCommit(state, updatedVehicle) {
            const index = state.listeVehicles.findIndex(v => v._id === updatedVehicle._id)
            if (index !== -1) {
                state.listeVehicles.splice(index, 1, updatedVehicle)
            }
        },
        removeVehicleCommit(state, vehicleId) {
            state.listeVehicles = state.listeVehicles.filter(v => v._id !== vehicleId)
            state.count = state.listeVehicles.length
        },
        setErrors(state, error) {
            state.errors = error
        }
    },
    actions: {
        async fetchVehicles({commit}) {
            commit('setLoadingState', true)
            try {
                const response = await PortefeuilleService.getPortefeuille()
                // L'API retourne { portefeuille: { vehicules: [...], logements: [...], ... } }
                const vehicles = (response.data.portefeuille && response.data.portefeuille.vehicules) || []
                commit('setVehicles', vehicles)
                return vehicles
            } catch (error) {
                console.error('Erreur chargement vehicules:', error)
                commit('setErrors', error)
                throw error
            } finally {
                commit('setLoadingState', false)
            }
        },
        async addVehicle({commit}, vehicleData) {
            try {
                const response = await VehicleService.createVehicle(vehicleData)
                // L'API retourne { msg: "...", car: {...} }
                const vehicle = response.data.car
                commit('addVehicleCommit', vehicle)
                return vehicle
            } catch (error) {
                console.error('Erreur ajout vehicule:', error)
                commit('setErrors', error)
                throw error
            }
        },
        async updateVehicle({dispatch, commit}, {id, vehicleData}) {
            try {
                const response = await VehicleService.updateVehicle(id, vehicleData)
                await dispatch('fetchVehicles')
                return response.data
            } catch (error) {
                console.error('Erreur modification vehicule:', error)
                commit('setErrors', error)
                throw error
            }
        },
        async deleteVehicle({commit}, vehicleId) {
            try {
                const response = await VehicleService.deleteVehicle(vehicleId)
                const deletionResult = response && response.data && (response.data.response || response.data)

                if (!deletionResult || deletionResult.deletedCount !== 1) {
                    throw new Error('Vehicle deletion was not acknowledged by the API')
                }

                commit('removeVehicleCommit', vehicleId)
            } catch (error) {
                console.error('Erreur suppression vehicule:', error)
                commit('setErrors', error)
                throw error
            }
        }
    }
}

export default Vehicles
